<template>
  <div class="web-text-field">
    <input 
      ref="input" 
      :value="text" 
      :type="type" 
      :readonly="!editable" 
      :maxlength="maxLength"
      :aria-label="ariaLabel"
      :aria-describedby="ariaDescribedby"
      :aria-invalid="ariaInvalid"
      :autocomplete="autocomplete"
      :placeholder="placeholder"
      @input="emit" 
      @blur="$emit('blur')" 
      @focus="$emit('focus')" 
    />
  </div>
</template>

<script>

const modelProp = 'text'
const modelEvent = 'textChange'

export default {
  model: {
    prop: modelProp,
    event: modelEvent
  },
  props: {
    text: {
      default: ''
    },
    secure: {
      type: Boolean,
      default: false
    },
    keyboardType: {
      type: String
    },
    maxLength: {
      type: Number
    },
    editable: {
      type: Boolean,
      default: true
    },
    ariaLabel: {
      type: String,
      default: null
    },
    ariaDescribedby: {
      type: String,
      default: null
    },
    ariaInvalid: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  computed: {
    type () {
      if (this.secure) {
        return 'password'
      } else if (this.keyboardType === 'number') {
        return 'number'
      }

      return 'text'
    }
  },
  methods: {
    emit (event) {
      this.$emit(modelEvent, {
        object: this,
        eventName: modelEvent,
        oldValue: this.text,
        propertyName: modelProp,
        value: this.maxLength ? event.target.value.substr(0, this.maxLength) : event.target.value
      })
    },
    focus () {
      this.$refs.input.focus()
    }
  }
}

</script>

<style lang="scss" scoped>

html {
  .web-text-field {
    height: 100%;
    min-height: 24px;
    position: relative;
  }

  .web-text-field input {
    padding: inherit;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: transparent;
  }
}

</style>